<template>
  <div>
    <video-background
      :src="introVideo"
      img="@logo2.png"
      style="max-height: 400px; height: 100vh"
    >
    </video-background>
    <v-content>
      <section>
        <v-layout column wrap align-center>
          <v-flex xs12 sm4 class="my-3"> </v-flex>
          <v-flex xs12>
            <v-container grid-list-xl>
              <v-layout row wrap align-center>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="headline text-xs-center">
                      <v-icon x-large class="grey--text text--darken-2"
                        >mic</v-icon
                      >
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-xs-center">
                        Lovesongs for the Damned
                      </div>
                    </v-card-title>
                    <v-card-text
                      v-on:click="
                        goUrl(
                          'https://witchofthevale.bandcamp.com/album/lovesongs-for-the-damned-digital-copy-only',
                        )
                      "
                      v-on:keydown="
                        goUrl(
                          'https://witchofthevale.bandcamp.com/album/lovesongs-for-the-damned-digital-copy-only',
                        )
                      "
                    >
                      <p>
                        Lovesongs for the Damned is out now.
                        <a
                          target="_blank"
                          href="https://witchofthevale.bandcamp.com/album/100-ways-to-leave"
                          ><br />Bandcamp Link</a
                        >
                      </p>
                      <br />
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="headline text-xs-center">
                      <v-icon x-large class="grey--text text--darken-2"
                        >link</v-icon
                      >
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-xs-center">Linktree</div>
                    </v-card-title>
                    <v-card-text
                      v-on:click="goUrl('https://linktr.ee/witchofthevale')"
                    >
                      <p>
                        Keep up-to-date with our linktree.
                        <a
                          target="_blank"
                          href="https://linktr.ee/witchofthevale"
                          ><br />Linktree</a
                        >
                      </p>
                      <br />
                    </v-card-text>
                  </v-card>
                </v-flex>

                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text
                      class="text-xs-center"
                      v-on:click="
                        goUrl('https://www.justwatch.com/uk/movie/scavenger')
                      "
                    >
                      <v-icon x-large class="grey--text text--darken-2"
                        >music_video</v-icon
                      >
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-xs-center">
                        Movie Soundtracks
                      </div>
                    </v-card-title>
                    <v-card-text>
                      <p>
                        Fatured on the movie soundtracks for
                        <a
                          target="_blank"
                          href="https://cleorecs.com/store/shop/baphomet-dvd-or-blu-ray"
                          >Baphomet,
                        </a>
                        <a
                          target="_blank"
                          href="https://cleorecs.com/products/cocaine-werewolf-dvd-or-blu-ray"
                          >Cocaine Werewolf
                        </a>
                        and
                        <a
                          target="_blank"
                          href="https://www.youtube.com/watch?v=aNZQLC77KuI"
                          >Scavenger</a
                        >.
                      </p>
                      <br /><br />
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </section>

      <section>
        <v-parallax :src="landingOne" height="450">
          <v-layout column align-center justify-center class="white--text">
            <v-btn
              v-bind:style="{ opacity: '0.75' }"
              class="black lighten-2 mt-5"
              dark
              large
              color="rgb(255, 0, 0, 0.2)"
              v-on:click="
                goUrl('https://open.spotify.com/artist/7axp614rqaTEKnaeQJ8F3V')
              "
            >
              Listen on Spotify

              <v-icon>volume_up</v-icon>
            </v-btn>
          </v-layout>
        </v-parallax>
      </section>

      <section>
        <v-layout row wrap justify-center>
          <v-container grid-list-xl text-xs-center>
            <v-layout row wrap align-content-center>
              <v-flex>
                <iframe
                  style="border: 0; width: 560px; height: 435px"
                  src="https://bandcamp.com/VideoEmbed?track=384123550&bgcol=ffffff&linkcol=0687f5"
                  mozallowfullscreen="1"
                  webkitallowfullscreen="1"
                  allowfullscreen="1"
                  seamless
                ></iframe>
                <iframe
                  style="border: 0; width: 350px; height: 435px"
                  src="https://bandcamp.com/EmbeddedPlayer/album=3238442417/size=large/bgcol=333333/linkcol=0f91ff/tracklist=false/transparent=true/"
                  seamless
                  ><a
                    href="https://witchofthevale.bandcamp.com/album/commemorate-2"
                    >Commemorate by Witch of the Vale</a
                  ></iframe
                >
                <!-- <iframe style="border: 0; width: 350px; height: 435px;" src="https://bandcamp.com/EmbeddedPlayer/album=540761319/size=large/bgcol=181a1b/linkcol=056cc4/tracklist=false/transparent=true/" seamless><a href="http://witchofthevale.bandcamp.com/album/changeling">Changeling by Witch of the Vale</a></iframe>
                <iframe style="border: 0; width: 350px; height: 435px;" src="https://bandcamp.com/EmbeddedPlayer/album=618409990/size=large/bgcol=181a1b/linkcol=056cc4/tracklist=false/transparent=true/" seamless><a href="http://witchofthevale.bandcamp.com/album/the-way-this-will-end">The Way This Will End by Witch of the Vale</a></iframe> -->
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
      </section>

      <section>
        <v-parallax :src="landingTwo" height="500">
          <v-layout column align-center justify-center>
            <div class="headline white--text mb-3 text-xs-center">
              New Release
            </div>
            <em> Lovesongs for the Damned is out now </em>
            <br />
            <v-btn
              v-bind:style="{ opacity: '0.75' }"
              class="black lighten-2 mt-5"
              dark
              large
              color="rgb(255, 0, 0, 0.2)"
              v-on:click="goUrl('https://witchofthevale.bandcamp.com/')"
            >
              Buy Now
              <v-icon>shopping_cart</v-icon>
            </v-btn>
          </v-layout>
        </v-parallax>
      </section>

      <section>
        <v-layout row wrap justify-center>
          <v-flex xs12 sm7>
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline">Bio</div>
              </v-card-title>
              <v-card-text>
                <p>
                  An unsettling electronic duo from the serene shores of Loch
                  Lomond and the remote Outer Hebridean Isles. Witch of the Vale
                  released their debut album
                  <a
                    target="_blank"
                    href="https://witchofthevale.bandcamp.com/album/commemorate-2"
                  >
                    Commemorate
                  </a>
                  in December 2020 with
                  <a target="_blank" href="http://cleorecs.com/home/"
                    >Cleopatra Records</a
                  >
                  . They have also since been featured in the official movie
                  soundtracks for
                  <a
                    target="_blank"
                    href="https://cleorecs.com/store/shop/baphomet-dvd-or-blu-ray"
                    >Baphomet</a
                  >
                  ,
                  <a
                    target="_blank"
                    href="https://www.youtube.com/watch?v=aNZQLC77KuI"
                    >Scavenger</a
                  >
                  , and
                  <a
                    target="_blank"
                    href="https://cleorecs.com/products/cocaine-werewolf-dvd-or-blu-ray"
                    >Cocaine Werewolf</a
                  >
                  . 2024 saw the release of
                  <a
                    target="_blank"
                    href="https://witchofthevale.bandcamp.com/album/100-ways-to-leave"
                    >100 Ways to Leave</a
                  >, followed by
                  <a
                    target="_blank"
                    href="https://witchofthevale.bandcamp.com/album/lovesongs-for-the-damned-digital-copy-only"
                    >Lovesongs for the Damned</a
                  >
                  in 2026.
                </p>
                <section class="hidden-sm-and-down">
                  <br />
                </section>

                <p>
                  Witch of the Vale are best identified by their haunting vocal
                  style coupled with harmonic synths. These in turn are starkly
                  contrasted by deep drones and abrasive drums. Paired with
                  sincere and melancholic lyrics, their sound is at once
                  ethereal and devastating. Praised for their compelling and
                  tortured live performances, Witch of the Vale’s sound easily
                  compliments more energetic artists, providing a tempo break in
                  line-ups to deliver an atmospheric and deeply emotional
                  experience.
                </p>
                <section class="hidden-sm-and-down">
                  <br />
                </section>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm3 offset-sm1>
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline">Follow us</div>
              </v-card-title>
              <v-card-text>
                Keep up-to-date with recent news by following us on social
                media.
              </v-card-text>
              <v-list class="transparent">
                <v-list-tile
                  v-on:click="goUrl('https://www.facebook.com/witchofthevale/')"
                >
                  <v-list-tile-action>
                    <v-icon class="blue--text text--lighten-2">phone</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Facebook</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                  v-on:click="
                    goUrl('https://witchofthevale.bandcamp.com/releases')
                  "
                >
                  <v-list-tile-action>
                    <v-icon class="blue--text text--lighten-2"
                      >music_note</v-icon
                    >
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Bandcamp</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                  v-on:click="
                    goUrl('https://www.instagram.com/witch_of_the_vale/')
                  "
                >
                  <v-list-tile-action>
                    <v-icon class="blue--text text--lighten-2">place</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Instagram</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                  v-on:click="goUrl('https://twitter.com/WitchOfTheVale')"
                >
                  <v-list-tile-action>
                    <v-icon class="blue--text text--lighten-2">email</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Twitter</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                  v-on:click="
                    goUrl(
                      'https://open.spotify.com/artist/7axp614rqaTEKnaeQJ8F3V',
                    )
                  "
                >
                  <v-list-tile-action>
                    <v-icon class="blue--text text--lighten-2"
                      >music_note</v-icon
                    >
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Spotify</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </section>
      <section>
        <v-container>
          <v-layout row wrap align-content-center>
            <v-flex class="hidden-sm-and-down">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube-nocookie.com/embed/8YqecrIhRWY"
                title="YouTube video player"
                allow="
                  accelerometer;
                  autoplay;
                  clipboard-write;
                  encrypted-media;
                  gyroscope;
                  picture-in-picture;
                "
                allowfullscreen
              ></iframe>
              <iframe
                width="560"
                height="315"
                src="https://www.youtube-nocookie.com/embed/pkfdIwpRfOQ?start=6"
                title="YouTube video player"
                allow="
                  accelerometer;
                  autoplay;
                  clipboard-write;
                  encrypted-media;
                  gyroscope;
                  picture-in-picture;
                "
                allowfullscreen
              ></iframe>
            </v-flex>
            <v-flex class="hidden-md-and-up">
              <iframe
                width="280"
                height="157"
                src="https://www.youtube-nocookie.com/embed/8YqecrIhRWY"
                title="YouTube video player"
                allow="
                  accelerometer;
                  autoplay;
                  clipboard-write;
                  encrypted-media;
                  gyroscope;
                  picture-in-picture;
                "
                allowfullscreen
              ></iframe>
              <iframe
                width="280"
                height="157"
                src="https://www.youtube-nocookie.com/embed/pkfdIwpRfOQ?start=6"
                title="YouTube video player"
                allow="
                  accelerometer;
                  autoplay;
                  clipboard-write;
                  encrypted-media;
                  gyroscope;
                  picture-in-picture;
                "
                allowfullscreen
              ></iframe>
            </v-flex>
          </v-layout>
        </v-container>
      </section>
    </v-content>
  </div>
</template>

<style scoped>
a {
  color: #ff0000;
}

iframe {
  margin: auto !important;
}
</style>

<script>
export default {
  methods: {
    goUrl: function (link) {
      if (link) {
        const win = window.open(link, "_blank", "modal=no");
        win.focus();
      }
    },
  },
  data() {
    return {
      landingOne: require("@/assets/landing1Large.jpg"),
      landingTwo: require("@/assets/lsftdSmall.jpg"),
      introVideo: require("@/assets/intro-scaled.mp4"),
    };
  },
};
</script>
